import EmptyState from '@adsk/alloy-react-empty-state';
import { IllustrationType } from '@adsk/alloy-react-illustration';
import { styled, marginMixin, colors, boolean, css, variant, MarginMixinTypes } from '@adsk/nirvana-theme';

export const Action = styled.div``;
export const Footer = styled.div`
  color: ${colors.charcoal700};
  font-size: 12px;
  line-height: 18px;
  padding-top: 40px;
`;

export const Wrapper = styled(EmptyState)<
  {
    illustrationType: IllustrationType;
    centered: boolean;
  } & MarginMixinTypes
>`
  justify-content: center;

  ${boolean(
    'centered',
    css`
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `
  )}

  ${variant('size', {
    large: css`
      ${Action} {
        padding-top: 22px;
      }
      ${Footer} {
        font-size: 16px;
        line-height: 22px;
        padding-top: 72px;
      }
    `
  })}

  ${marginMixin}
`;
